import { render } from "./LoaderIcon.vue?vue&type=template&id=4d5fbc26&scoped=true&ts=true"
import script from "./LoaderIcon.vue?vue&type=script&lang=ts"
export * from "./LoaderIcon.vue?vue&type=script&lang=ts"

import "./LoaderIcon.vue?vue&type=style&index=0&id=4d5fbc26&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d5fbc26"]])

export default __exports__